export default __webpack_public_path__ + "static/media/clinic11.b7f9d8c9.jpg";